import api from '@/redux/api/curatedCollection';
import { createSelector } from '@reduxjs/toolkit';
import { getDeployment } from './config';
import { GlobalState } from '../rootReducer';

const LOAD_CURATED_COLLECTION_FAIL = 'LOAD_CURATED_COLLECTION_FAIL';
const LOAD_CURATED_COLLECTION_REQUEST = 'LOAD_CURATED_COLLECTION_REQUEST';
const LOAD_CURATED_COLLECTION_SUCCESS = 'LOAD_CURATED_COLLECTION_SUCCESS';

/* reducer */
export const DEFAULT_STATE = {
    error: false,
    isLoading: true,
    itemIds: [],
    label: '',
    totalFound: 0,
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case LOAD_CURATED_COLLECTION_REQUEST:
            return {
                ...state,
                error: false,
                submitted: true,
                success: false,
            };
        case LOAD_CURATED_COLLECTION_SUCCESS:
            return {
                ...state,
                itemIds: action.payload.lots,
                label: action.payload.label,
                submitted: false,
                success: true,
                totalFound: action.payload.lots ? action.payload.lots.length : 0,
                URLName: action.payload.name,
            };
        case LOAD_CURATED_COLLECTION_FAIL:
            return {
                ...state,
                error: true,
                submitted: false,
                success: false,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.curatedCollection;

export const getCuratedCollectionItemIds = createSelector(stateSelector, (state) => state.itemIds || []);

export const getCuratedCollectionTotalFound = createSelector(stateSelector, (state) => state.totalFound || 0);

export const getCuratedCollectionLabel = createSelector(stateSelector, (state) => state.label || 'Example Label');

/* ACTION CREATORS */
export const fetchCuratedCollectionData = (collectionID: any) => async (dispatch: Function, getState: Function) => {
    try {
        const state = getState();
        const deployment = getDeployment(state);
        dispatch({
            type: LOAD_CURATED_COLLECTION_REQUEST,
        });

        // Annotate facets which have user-defined search exclusions
        const results = await api.fetchCuratedCollectionItemIDs({ collectionID, deployment });
        dispatch({
            payload: results.payload,
            type: LOAD_CURATED_COLLECTION_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            meta: { collectionID },
            payload: error,
            type: LOAD_CURATED_COLLECTION_FAIL,
        });
    }
};
